
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NodeFormMixin from '../forms/NodeFormMixin';
import { ResolveController } from 'rt/UIApiControllers/UI/Smart/ResolveController';

@Component({
  name: 'AccountSummary',
})
export default class ListSummary extends NodeFormMixin {
  resolveController = new ResolveController(Vue.axios);

  listDescription: string = null;

  async mounted() {
    await this.handleActionChange();
  }

  @Watch('data.action', { deep: true })
  async handleActionChange() {
    if (this.data.action.listId > 0) {
      this.listDescription = (await this.resolveController.List(this.data.action.listId)).name;
    } else {
      this.listDescription = null;
    }
  }
}
